import * as firebase from "firebase/app";
import "firebase/analytics";

export interface Authenticator {
  init: () => Promise<void>;
}

export class StubAuthenticator implements Authenticator {
  init = async () => {
    await delay(500);
  };
}

const delay = (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export class FirebaseAuthenticator implements Authenticator {
  init = async () => {
    // firebase.initializeApp(firebaseConfig);
    // firebase.analytics();
  };
}

const primaryFirebaseConfig = {
  apiKey: "AIzaSyBDsdZd3vD2Keh3azIDtopfl6t1z4lXTCg",
  authDomain: "booksmarts-marketing.firebaseapp.com",
  projectId: "booksmarts-marketing",
  storageBucket: "booksmarts-marketing.appspot.com",
  messagingSenderId: "886797302245",
  appId: "1:886797302245:web:1e97da481fd2b59c62170c",
  measurementId: "G-NZZHTFXZ3Z",
};

const combinedFirebaseConfig = {
  apiKey: "AIzaSyCcQEYWHl5Zu7oo2dh-gcx5KsQGa9ZrQ9E",
  authDomain: "booksmarts-combined.firebaseapp.com",
  projectId: "booksmarts-combined",
  storageBucket: "booksmarts-combined.appspot.com",
  messagingSenderId: "72644970899",
  appId: "1:72644970899:web:5f5ba977d5e2319a5c0066",
  measurementId: "G-00QDKRWWJT",
};

export const primaryFirebaseApp = firebase.initializeApp(primaryFirebaseConfig);
export const combinedFirebaseApp = firebase.initializeApp(
  combinedFirebaseConfig,
  "combined"
);



// WEBPACK FOOTER //
// ./src/utils/Auth.ts